export default "__VITE_ASSET__VsL0RT_C__"